import { Modal } from "react-bootstrap";
import { IItemComErro } from "..";
import { Table } from "containers/Table";
import { FaArrowLeft } from "react-icons/fa";
import { utils, writeFileXLSX } from "xlsx";

interface IProps {
  itens: IItemComErro[];
  labelItem?: string;
  onVoltar: () => void;
}

export function CustomInputModalBodyDetalhes({
  itens,
  labelItem,
  onVoltar,
}: IProps) {
  const columns = [
    {
      name: labelItem ?? "Item",
      selector: ({ item }: IItemComErro) => <span>{item ?? "- -"}</span>,
    },
    {
      name: "Descrição do erro",
      selector: ({ mensagem }: IItemComErro) => (
        <span>{mensagem ?? "- -"}</span>
      ),
    },
  ];

  const handleExport = () => {
    const dadosPlanilha = itens.map((item) => ({
      [labelItem ?? "Item"]: item.item,
      "Descrição do erro": item.mensagem,
    }));

    const planilha = utils.json_to_sheet(dadosPlanilha);
    planilha["!cols"] = [{ wch: 20 }, { wch: 40 }];
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, planilha, "Detalhes");
    writeFileXLSX(workBook, "revisao.xlsx");
  };

  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title>Revisão</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ paddingBottom: "24px" }}>
        <Table
          columns={columns}
          data={itens}
          keyField={labelItem ?? "Item"}
          loading={false}
          exportExcel
          handleExport={handleExport}
          buttonExportVariant="secondary"
          toolsHeader={
            <div style={{ width: "70px" }}>
              <span onClick={onVoltar} style={{ cursor: "pointer" }}>
                <FaArrowLeft style={{ marginRight: "5px" }} /> Voltar
              </span>
            </div>
          }
        />
      </Modal.Body>
    </div>
  );
}
